import { useContext, createContext } from 'react';
export var SplitPanelContext = createContext({
    topOffset: 0,
    bottomOffset: 0,
    leftOffset: 0,
    rightOffset: 0,
    position: 'bottom',
    size: 0,
    getMaxWidth: function () { return 0; },
    getMaxHeight: function () { return 0; },
    isCopy: false,
    isOpen: true,
    isMobile: false,
    isRefresh: false,
    isForcedPosition: false,
    lastInteraction: undefined,
    splitPanelRef: undefined,
    splitPanelHeaderRef: undefined,
    onResize: function () { },
    onToggle: function () { },
    onPreferencesChange: function () { },
    reportSize: function () { }
});
export function useSplitPanelContext() {
    return useContext(SplitPanelContext);
}
//# sourceMappingURL=split-panel-context.js.map